import { Gender } from './gender';
import { OwnershipType } from './ownershipType';
import { MaritalStatus } from './martitalStatus';
import { RelationShipWithPrimary } from './relationshipWithPrimary';
import { OccupationStatus } from './occupationStatus';
import { AbbToEmi } from './abbToEmi';
import { TypeOfApplicant } from './typeOfApplicant';

export class Dropdown {
    genderTypcodeDtos: Gender[] = [];
    maritalStatTypcodeDtos: MaritalStatus[] = [];
    residentStatTypcodeDtos: OwnershipType[] = [];
    cstPrimaryRelTypcodeDtos: RelationShipWithPrimary[] = [];
    cstOccupationTypcodeDtos: OccupationStatus[] = [];
    abbToEmiTypcodeDtos: AbbToEmi[] = [];
    cstApplicantTypTypcodeDtos: TypeOfApplicant[] = [];
}
